// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a4c86cc1","667":"487484f5","977":"7753c7bd"}[chunkId] + ".chunk.js";
};